import getNotifications from "./actions/get_notifications";
import updateNotifications from "./actions/update_notifications";
import fetchNotification from "./actions/fetch_notification";

export default {
    getNotifications,
    updateNotifications,
    fetchNotification
};
